import {
  isUserIneligibleAtom,
  redirectVariantAtom,
} from "@mirage/eligibility/useEligibilityCheck";
import { RedirectVariant } from "@mirage/mosaics/FullPageRedirect/types";
import { useWelcomeModalDismissed } from "@mirage/service-onboarding/hooks";
import { atom, useAtom, useAtomValue } from "jotai";
import { useEffect } from "react";

export const shouldShowWelcomeModalAtom = atom<boolean | undefined>(undefined);
export function useShouldShowWelcomeModal(modalVersion: number) {
  const [shouldShowModal, setShouldShowModal] = useAtom(
    shouldShowWelcomeModalAtom,
  );
  const isUserIneligible = useAtomValue(isUserIneligibleAtom);
  const redirectVariant = useAtomValue(redirectVariantAtom);
  const { dismissed, setDismissed, initialized } =
    useWelcomeModalDismissed(modalVersion);

  useEffect(() => {
    if (modalVersion === 2) {
      // Modal version 2 is the FSS Preview modal associated with the bridge onboarding flow.
      const shouldShow =
        !dismissed && redirectVariant === RedirectVariant.BridgeOnboarding;
      setShouldShowModal(shouldShow);
    } else {
      const shouldShow = !dismissed && !isUserIneligible;
      setShouldShowModal(shouldShow);
    }
  }, [
    dismissed,
    isUserIneligible,
    modalVersion,
    redirectVariant,
    setShouldShowModal,
  ]);

  return {
    shouldShowModal,
    dismissed,
    setDismissed,
    initialized,
  };
}
